import React from 'react';
import i18next from 'i18next';
import BtnGroup from '../../BtnGroup/BtnGroup';
import Button from '../../Button/Button';
import { connect } from 'react-redux';

class EventsNav extends React.Component {
  render() {
    const { eventsType, onChange, counts } = this.props;
    return (
      <div className="events-nav">
        <BtnGroup>
          <Button
            defaultStyles
            onClick={onChange.bind(this, 'all')}
            active={eventsType === 'all' ? 'active' : null}
          >
            {i18next.t('events_nav.all')}
            <span>{counts['all']}</span>
          </Button>
          <Button
            defaultStyles
            onClick={onChange.bind(this, 'prematch')}
            active={eventsType === 'prematch' ? 'active' : null}
          >
            {i18next.t('events_nav.prematch')}
            <span>{counts['prematch']}</span>
          </Button>
          <Button
            defaultStyles
            onClick={onChange.bind(this, 'live')}
            active={eventsType === 'live' ? 'active' : null}
          >
            {i18next.t('events_nav.live')}
            <span>{counts['live']}</span>
          </Button>
        </BtnGroup>
      </div>
    );
  }
}

export default connect((state) => {
  return {
    counts: state.events.counts,
  };
}, {})(EventsNav);



// WEBPACK FOOTER //
// ./app/components/EsportsGame/EventsNav/EventsNav.jsx